<template>
  	<div id="Astronaut">
    	<div class="row p-0 m-0 align-items-center justify-content-center">
      		<div class="col p-0 m-0 text-center" v-if="checkStatusSite">
				<img
					:src="handleLoadingAnimation"
					class="logo my-5"
					alt="Criando site"
					@click="toggle = !toggle"
				/>
				<p class="mt-5">Criando site...</p>
			</div>
			<transition name="slide">
				<div class="col-10 p-0 mb-4 text-center container-finish-content" v-if="!checkStatusSite">
					<div class="fireworks">
						<div class="dot"></div>
						<div class="dot"></div>
						<div class="dot"></div>
						<div class="dot"></div>
						<div class="bar"></div>
						<div class="bar"></div>
						<div class="bar"></div>
						<div class="bar"></div>
						<div class="star">&times;</div>
						<div class="star">&times;</div>
						<div class="star">&times;</div>
					</div>
						<div class="finish-message" @click="toggle = !toggle">
							<span>Uhuuu! <br/> Site pronto</span>
						</div>
						<div class="timer">
							<p>em apenas 😱</p>
							<p>{{calculateTime}}</p>
							<div class="min-sec"><span>MIN.</span><span>SEG.</span></div>
						</div>
				</div>
			</transition>
    	</div>
  	</div>
</template>

<script>
export default {
	name: "Astronaut",
  	data() {
    	return {
			toggle: true,
      		classBackground: [{ backgroundColor: "" }]
    	};
  	},
  	mounted() {
		// this.$store.dispatch("VERIFY_TOKEN");
  	},
  	computed: {
		handleLoadingAnimation(){
			const applicationId = this.$store.state.application.id
			if(applicationId === 1 || applicationId === 3 || applicationId === 4){
				return require('../assets/img/astronauta.gif');
			}else if (applicationId === 2){
				return require('../assets/img/construindo-site-aviao-sitejet.gif');
			}else if(applicationId === 5){
				return require('../assets/img/astronauta-verde.gif');
			}
		},
		calculateTime() {
			const startAt = this.$store.state.wizard.dataSite.createTime.startTime;
			const finishAt = this.$store.state.wizard.dataSite.createTime.finishTime;
			var delta = Math.abs(finishAt - startAt) / 1000;
			var days = Math.floor(delta / 86400);
			delta -= days * 86400;
			var hours = Math.floor(delta / 3600) % 24;
			delta -= hours * 3600;
			var minutes = Math.floor(delta / 60) % 60;
			delta -= minutes * 60;
			var seconds = Math.floor(delta % 60);
			minutes = this.timeEdit(minutes);
			seconds = this.timeEdit(seconds);
			return `${minutes}:${seconds}`;
    	},
    	checkStatusSite() {
			if (this.$store.state.wizard.dataSite.createTime.finishTime == null) {
				return true;
			} else {
				return false;
			}
    	}
  	},
	methods:{
		timeEdit(time){
			if(time.toString().length == 1 ){
				time = `0${time}`
			}
			return time
		},
	}
};
</script>

<style scoped>
#Astronaut {
	background-color: var(--bg-color);
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 10;
	color: #ffffff;
	background-image: url("../assets/img/Uli-Fundo-Painel-desktop-load-branco.png");
	background-repeat: no-repeat;
	background-position: center bottom;
}
@media all and (max-width: 998px) {
	#Astronaut {
		background-image: url("../assets/img/Uli-Fundo-Painel-mobile-load-branco.png");
		background-size: cover;
	}
}
#Astronaut > .row {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}
#Astronaut img {
  	width: 251px;
}
.container-finish-content{
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
}
.fireworks{
	height: 190px;
	width: 350px;
	position: relative;
}
.dot{
	width: 6px;
	height: 6px;
	background-color: #fff;
	border-radius: 50%;
	margin: 5px;
	position: absolute;
}
.bar {
    background-color: #fff;
    width: 5px;
    height: 39px;
    margin: 5px;
    border-radius: 20px;
	position: absolute;
}
.star{
	font-weight: 700;
	color: #fff;
	font-size: 2rem;
	position: absolute;
}
.fireworks .dot:nth-child(1){
	left: 100px;
	bottom: 80px;

	animation: dotOne 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .dot:nth-child(2){
	left: 110px;
	bottom: 120px;

	animation: dotTwo 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
	
}
.fireworks .dot:nth-child(3){
	right: 135px;
	bottom: 150px;

	animation: dotThree 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .dot:nth-child(4){
	right: 105px;
	bottom: 105px;

	animation: dotFour 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .bar:nth-child(5){
	left: 115px;
	bottom: 80px;
    -webkit-transform: rotate(145deg);
    transform: rotate(145deg);

	animation: barOne 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .bar:nth-child(6){
	height: 22px;
	left: 49%;
	bottom: 157px;

	animation: barTwo 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .bar:nth-child(7){
    height: 22px;
	left: 49%;
	bottom: 125px;

	animation: barThree 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .bar:nth-child(8){
	right: 110px;
	bottom: 107px;
    transform: rotate(54deg);
    -webkit-transform: rotate(54deg);

	animation: barFour 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .star:nth-child(9){
	left: 133px;
    bottom: 126px;

	animation: starOne 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .star:nth-child(10){
	right: 120px;
    bottom: 67px;
    -webkit-transform: rotate(74deg);
    transform: rotate(74deg);

	animation: starTwo 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.fireworks .star:nth-child(11){
	right: 76px;
    bottom: 134px;

	animation: starThree 3s 1;
	animation-fill-mode: forwards;
	animation-delay: 1s;
}
.finish-message{
	min-height: 15%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
	padding-bottom: 30px;
}
.timer{
	height: 27%;
	font-size: 1.3rem;
}
.timer p{
	margin: 0;
}
.timer p:nth-child(2){
	font-size: 3rem;
    font-weight: lighter;
	line-height: 3rem;
}
.min-sec{
	display: flex;
	justify-content: space-around;
	font-weight: 500;
}.slide-enter-to{
	margin-top: 0px;
}
.slide-enter-active, .slide-leave-active{
	transition: all 2s;
}
.slide-enter, .slide-leave-to{
  	opacity: 0;
	margin-top: 20px;
}
@keyframes dotOne {
	from{
		left: 100px;
		bottom: 80px;
	}
	to{
		left: 0;
		bottom: 0;
		opacity: 0;
	}
}
@keyframes dotTwo {
	from{
		left: 110px;
    	bottom: 120px;
	}
	to{
		left: 0;
		bottom: 240px;
		opacity: 0;
	}
}
@keyframes dotThree {
	from{
		right: 135px;
    	bottom: 150px;
	}
	to{
		right: 0px;
    	bottom: 240px;
		opacity: 0;
	}
}
@keyframes dotFour {
	from{
		right: 105px;
    	bottom: 105px;
	}
	to{
		right: 0px;
    	bottom: 100px;
		opacity: 0;
	}
}
@keyframes barOne {
	from{
		left: 115px;
		bottom: 80px;
	}
	to{
		left: 65px;
		bottom: 140px;
		opacity: 0;
	}
}
@keyframes barTwo {
	from{
		left: 49%;
		bottom: 157px;
	}
	to{
		left: 49%;
		bottom: 250px;
		opacity: 0;
	}
}
@keyframes barThree {
	from{
		left: 49%;
		bottom: 125px;
	}
	to{
		left: 49%;
		bottom: 200px;
		height: 35px;
		opacity: 0;
	}
}
@keyframes barFour {
	from{
		right: 110px;
    	bottom: 107px;
	}
	to{
		right: 60px;
    	bottom: 147px;
		opacity: 0;
	}
}
@keyframes starOne {
	from{
		left: 133px;
    	bottom: 126px;
	}
	to{
		left: 83px;
    	bottom: 186px;
		opacity: 0;
	}
}
@keyframes starTwo {
	from{
		right: 120px;
		bottom: 67px;
		-webkit-transform: rotate(74deg);
		transform: rotate(74deg);
	}
	to{
		right: 80px;
    	bottom: -33px;
		-webkit-transform: rotate(54deg);
		transform: rotate(54deg);
		opacity: 0;
	}
}
@keyframes starThree {
	from{
		right: 76px;
    	bottom: 134px;
	}
	to{
		right: 26px;
    	bottom: 170px;
		opacity: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Astronaut.vue